define('services/qm/qualityAdminState',[
    'lib/knockout'
], function (ko) {
    'use strict';

    /**
     * This is used to pass state between between the quality admin dashboards and the Evaluators page in web-contact-center-quality
     * The main variable being passed is the Start and EndTime of selections
     */
    return {
        timeFrame: ko.observable()
    };
});

